export default __webpack_public_path__ + "static/media/631336ef02a20648671962097d72e486.svg";